<template>

  <div class="addStoryInJourney">

    <v-container class="mt-12 mb-0 pb-0 px-0 mx-2">
<v-row align="center"><v-col align="center" cols=12>{{$t('selectOneOfCreatedJourney')}}</v-col></v-row>
          <v-row @click="selectJourney(item.id)" :key="item.id" v-for="(item) in userDraftJourney" justify="center"
            align="center" dark :style="selectedJourneyID==item.id?'outline-color: colorPalettejourneydarker' + item.backgroundColor :''" :class="selectedJourneyID==item.id?'colorPalettejourneydarker'+item.backgroundColor+' mt-2':'colorPalettejourney'+item.backgroundColor+' mt-2'">
            <v-col col=3 v-if="item.storiesArrayObjectIdDescription.length == 0" >Journey without stories. No cover to display</v-col>
            <v-col v-else col=3 class="px-0 mt-0 pb-0 pt-0" style="width=100%">
              <v-img v-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats==null" class="coverImageStyle"
                :src="require('@/assets/placeholder.png')"></v-img>
              <mediaFileStory v-else-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter!=null" class="coverImageStyle"
                :mediaUrl=" apiStrapi +'/uploads/'+ item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter.hash + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter.ext"
                :type="item.storiesArrayObjectIdDescription[0].cover_image.type" :isLocal="false" :isThumbnail="true" />
              <mediaFileStory v-else-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small !=null" class="coverImageStyle"
                :mediaUrl=" apiStrapi +'/uploads/'+ item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small.hash + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small.ext"
                :type="item.storiesArrayObjectIdDescription[0].cover_image.type" :isLocal="false" :isThumbnail="true" />
              <mediaFileStory v-else-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail!=null" class="coverImageStyle"
                :mediaUrl=" apiStrapi +'/uploads/'+ item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail.hash + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail.ext"
                :type="item.storiesArrayObjectIdDescription[0].cover_image.type" :isLocal="false" :isThumbnail="true" />
              <v-img v-else class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>
            </v-col>
            <v-col class="col-7 px-4 mt-0 pb-0 mb-0">
              <v-row>
                <h2 class="mt-0 mb-0 pt-0 mb-0">{{item.journeyTitle}}</h2>
                                            </v-row>

                              <v-row>

                <p class="mt-0 mb-0 pt-0 mb-0">{{item.journeyDescription}}</p>
              </v-row>
            </v-col>
          </v-row>

          <v-row @click="selectJourney(item.id)" :key="item.id" v-for="(item) in userPublicJourney" justify="center"
            align="center" dark :style="selectedJourneyID==item.id?'outline-color: colorPalettejourneydarker' + item.backgroundColor :''" :class="selectedJourneyID==item.id?'colorPalettejourneydarker'+item.backgroundColor+' mt-2':'colorPalettejourney'+item.backgroundColor+' mt-2'">
            <v-col col=3 v-if="item.storiesArrayObjectIdDescription.length == 0" >Journey without stories. No cover to display</v-col>
            <v-col v-else col=3 class="px-0 mt-0 pb-0 pt-0">
              <v-img v-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats==null" class="coverImageStyle"
                :src="require('@/assets/placeholder.png')"></v-img>
              <mediaFileStory v-else-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter!=null" class="coverImageStyle"
                :mediaUrl=" apiStrapi +'/uploads/'+ item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter.hash + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.coverImageCenter.ext"
                :type="item.storiesArrayObjectIdDescription[0].cover_image.type" :isLocal="false" :isThumbnail="true" />
              <mediaFileStory v-else-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small !=null" class="coverImageStyle"
                :mediaUrl=" apiStrapi +'/uploads/'+ item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small.hash + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.small.ext"
                :type="item.storiesArrayObjectIdDescription[0].cover_image.type" :isLocal="false" :isThumbnail="true" />
              <mediaFileStory v-else-if="item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail!=null" class="coverImageStyle"
                :mediaUrl=" apiStrapi +'/uploads/'+ item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail.hash + item.storiesArrayObjectIdDescription[0].cover_image.media.formats.thumbnail.ext"
                :type="item.storiesArrayObjectIdDescription[0].cover_image.type" :isLocal="false" :isThumbnail="true" />
              <v-img v-else class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>
            </v-col>
            <v-col class="col-7 px-4 mt-0 pb-0 mb-0">
              <v-row>
                <h2 class="mt-0 mb-0 pt-0 mb-0">{{item.journeyTitle}}</h2>
                                                            </v-row>
                              <v-row>
                <p class="mt-0 mb-0 pt-0 mb-0">{{item.journeyDescription}}</p>
              </v-row>
            </v-col>
          </v-row>

        <v-btn  style="position: fixed;top: 80vh;" v-if="selectedJourneyID==null" fab right disable bottom absolute dark large >
          <v-icon  dark>
            mdi-check-bold
          </v-icon>
        </v-btn>
        <v-btn style="position: fixed;top: 80vh;" @click="goToCreateNewJourneyContent()" v-else fab right bottom absolute dark large color="primary">
          <v-icon  dark>
            mdi-check-bold
          </v-icon>
        </v-btn>
        
        </v-container>

  </div>
</template>

<script>
import mediaFileStory from "@/components/mediaFileStory.vue"

//import getUserDraftJourney from '@/mockData/getUserDraftJourney.json'
//import getUserPublicJourney from '@/mockData/getUserPublicJourney.json'
//import {mapState} from 'vuex';

export default {
  name: "addStoryInJourney",
  components: {
    mediaFileStory
  },
  data: () => ({
    selectedJourneyID:null,
        apiUrl: process.env.VUE_APP_ROOT_API,
    apiStrapi: process.env.VUE_APP_ROOT_STRAPI,
userDraftJourney:[],
userPublicJourney:[]
  }),

  mounted() {
    this.getUserJourneysPublic()
    this.getUserJourneysDraft()
          },
            computed: {
      isToggleJourneyView: {
      get: function () {
        return this.$store.getters.getIsJourneyOrSingleStory;
      }
    }
    //, ...mapState(['user','userPublicJourney','userDraftJourney'])
  },
  methods:
  {
        async getUserJourneysPublic() {
      try {
        let completeurl = this.apiUrl + '/getUserPublicJourney?content=true&short=30'
        let tempUserJourneysPublic
        tempUserJourneysPublic = await this.getaxiosResponse(completeurl)
        this.userPublicJourney = tempUserJourneysPublic.data
      } catch (error) {
        if (error.response.status== 401){
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
          
        }
        else if (error.response.status== 401){
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          }).then(()=>this.gotopage('/splashScreen'))
        }
      else {
        this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
        }

      }
    },
    async getUserJourneysDraft() {
      try {

        let completeurl = this.apiUrl + '/getUserDraftJourney?content=true&short=100'
        let tempGetUserJourneysDraft
        tempGetUserJourneysDraft = await this.getaxiosResponse(completeurl)
        this.userDraftJourney = tempGetUserJourneysDraft.data
      } catch (error) {
        if (error.response.status== 401){
          this.myJourneysSavedList = []
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
          
        }
        else if (error.response.status== 401){
          this.myJourneysSavedList = []
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          }).then(()=>this.gotopage('/splashScreen'))
        }
      else {
        this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
        }

      }
    },
    selectJourney:function(idJourney){
      if (this.selectedJourneyID==idJourney){
        this.selectedJourneyID=null
      }else{
      this.selectedJourneyID=idJourney

      }
    }
    ,
        goToCreateNewJourneyContent:function(){
      this.$store.dispatch('clearNewJourney')
        this.$router.push({
          'name': 'createNewJourneyContent',
          'query':{idStory:this.$route.query.idStory,idJourney:this.selectedJourneyID}
        })
      },
    async getUserPublicJourney() {
      try {
        //console.log("getSingleStory")

        this.$store.dispatch('setLoading', true)
        let completeurl = this.apiUrl + '/getUserPublicJourney'
        let tempSingleStoryDetail
        tempSingleStoryDetail = await this.getaxiosResponse(completeurl)

        this.userPublicJourney = tempSingleStoryDetail.data

        this.$store.dispatch('setLoading', false)
if (tempSingleStoryDetail==null){
  console.log('you do not have the correct credentials to view the journey')
        this.$router.push({
          name: 'errorPage'
        })
}
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: 'errorPage'
        })
      }
    },
    async getUserDraftJourney() {
      try {
        //console.log("getSingleStory")

        this.$store.dispatch('setLoading', true)
        let completeurl = this.apiUrl + '/getUserDraftJourney'
        let tempSingleStoryDetail
        tempSingleStoryDetail = await this.getaxiosResponse(completeurl)

        this.userDraftJourney = tempSingleStoryDetail.data

        this.$store.dispatch('setLoading', false)
if (tempSingleStoryDetail==null){
  console.log('you do not have the correct credentials to view the journey')
        this.$router.push({
          name: 'errorPage'
        })
}
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: 'errorPage'
        })
      }
    }
  }
}
</script>
<style scoped>
.coverImageStyle{
width: 40vw;
max-width: 280px;
margin: auto;
}
</style>
